export default __webpack_public_path__ + "static/media/about-service-in-two-minutes.9c4b1804.png";